/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Newsletter_Unsubscribe_Meta_DescriptionInputs */

const ja_playdata_newsletter_unsubscribe_meta_description = /** @type {(inputs: Playdata_Newsletter_Unsubscribe_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA メールマガジンの配信を停止します。`)
};

const en_playdata_newsletter_unsubscribe_meta_description = /** @type {(inputs: Playdata_Newsletter_Unsubscribe_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsubscribe from the PLAYDATA newsletter.`)
};

/**
* | output |
* | --- |
* | "Unsubscribe from the PLAYDATA newsletter." |
*
* @param {Playdata_Newsletter_Unsubscribe_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_newsletter_unsubscribe_meta_description = /** @type {((inputs?: Playdata_Newsletter_Unsubscribe_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Newsletter_Unsubscribe_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_newsletter_unsubscribe_meta_description(inputs)
	return en_playdata_newsletter_unsubscribe_meta_description(inputs)
});